import React, { useState, useEffect } from 'react';
import { emailServiceCDN } from '../services/emailServiceCDN';
import './Introduction.css';
// Import des images de drapeaux (réutilisation)
import ukFlag from '../images/united-kingdom.png';
import turkeyFlag from '../images/turkey.png';
import franceFlag from '../images/france.png';
import { trackFormSubmit } from '../services/trackingService';

const IntroductionFirebase = () => {
    const [formData, setFormData] = useState({
        nom: '',
        email: '',
        telephone: '',
        sujet: '',
        message: ''
    });
    const [status, setStatus] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [firebaseReady, setFirebaseReady] = useState(false);
    const [emailReady, setEmailReady] = useState(false);
    // Nouveaux états pour l'export email
    // Initialiser Firebase au chargement
    useEffect(() => {
        const initFirebase = () => {
            if (typeof window !== 'undefined' && window.firebase && !window.firebaseApp) {
                try {
                    const firebaseConfig = {
                        apiKey: "AIzaSyC1yaePZ_CkNCev7kD747d72nIc4_tDWVM",
                        authDomain: "newschool-form.firebaseapp.com",
                        databaseURL: "https://newschool-form-default-rtdb.europe-west1.firebasedatabase.app",
                        projectId: "newschool-form",
                        storageBucket: "newschool-form.firebasestorage.app",
                        messagingSenderId: "340466982381",
                        appId: "1:340466982381:web:024b941dcd51dfb0bf5be4",
                        measurementId: "G-ZVYY0KSKGC"
                    };

                    window.firebaseApp = window.firebase.initializeApp(firebaseConfig);
                    window.firebaseDb = window.firebase.database();
                    setFirebaseReady(true);
                    console.log('✅ Firebase Realtime Database initialisé avec succès');
                } catch (error) {
                    console.error('Erreur Firebase:', error);
                }
            } else if (!window.firebase) {
                // Réessayer si Firebase n'est pas encore chargé
                setTimeout(initFirebase, 1000);
            }
        };

        // Initialiser EmailJS au chargement
        const initEmailJS = async () => {
            try {
                const isReady = await emailServiceCDN.testConnection();
                setEmailReady(isReady);
                console.log('EmailJS status:', isReady ? 'Ready' : 'Not ready');
            } catch (error) {
                console.error('Erreur lors de l\'initialisation EmailJS:', error);
            }
        };

        initFirebase();
        initEmailJS();
    }, []);

    const validateForm = () => {
        const newErrors = {};

        if (!formData.nom.trim()) {
            newErrors.nom = 'Le nom est requis';
        }

        if (!formData.email.trim()) {
            newErrors.email = 'L\'email est requis';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = 'Veuillez entrer un email valide';
        }

        if (!formData.telephone.trim()) {
            newErrors.telephone = 'Le numéro de téléphone est requis';
        }

        if (!formData.sujet.trim()) {
            newErrors.sujet = 'Le sujet est requis';
        }

        if (!formData.message.trim()) {
            newErrors.message = 'Le message est requis';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        if (!firebaseReady) {
            setStatus('⏳ Nos services se chargent. Veuillez patienter quelques instants et réessayer.');
            return;
        }

        setIsSubmitting(true);
        setStatus('');

        try {
            // Sauvegarder dans Firebase Realtime Database
            const contactsRef = window.firebaseDb.ref('contacts');
            const dataWithTimestamp = {
                ...formData,
                timestamp: new Date().toISOString(),
                submittedAt: Date.now(),
                status: 'nouveau',
                source: 'website'
            };

            const result = await contactsRef.push(dataWithTimestamp);

            if (result.key) {
                trackFormSubmit('contact_form', 'Introduction', { sujet: formData.sujet });
                setStatus('✅ Votre demande a été envoyée avec succès ! Nous vous contacterons rapidement.');

                // EmailJS configuré via API key - gestion automatique des emails
                try {
                    await emailServiceCDN.sendNotificationEmail(formData);
                    console.log('✅ EmailJS configuré pour envoi automatique');
                } catch (emailError) {
                    console.error('❌ Erreur EmailJS:', emailError);
                    // On continue même si EmailJS pose problème, car Firebase a fonctionné
                }

                // Réinitialiser le formulaire
                setFormData({
                    nom: '',
                    email: '',
                    telephone: '',
                    sujet: '',
                    message: ''
                });
            } else {
                setStatus('❌ Erreur lors de l\'envoi. Veuillez réessayer ou nous contacter directement.');
            }

        } catch (error) {
            console.error('Erreur:', error);
            setStatus('❌ Une erreur technique s\'est produite. Veuillez réessayer ou nous contacter par téléphone.');
        } finally {
            setIsSubmitting(false);
        }
    };

    // New: Export newsletter emails to PDF and open in a new tab
    // Nouvelle fonction : export et envoi par EmailJS

    return (
        <section id="introduction" className="introduction-section">
            <div className="container">
                <div className="intro-content">
                    <div className="intro-text">
                        <h2>À propos de New School</h2>
                        <p>
                            New School est une école de langues moderne qui se spécialise dans l'enseignement
                            de l'anglais, du turc et du français. Notre approche pédagogique innovante combine
                            les méthodes traditionnelles avec les dernières technologies pour offrir une
                            expérience d'apprentissage unique et efficace.
                        </p>
                        <p>
                            Nos instructeurs qualifiés et expérimentés sont dédiés à aider chaque étudiant
                            à atteindre ses objectifs linguistiques, que ce soit pour des raisons académiques,
                            professionnelles ou personnelles.
                        </p>
                        {/* Drapeaux sous le texte - réutilise les styles existants */}
                        <div className="flags_container d-flex align-items-center justify-content-center" aria-label="Langues proposées">
                            <div className="flag_wrapper">
                                <img src={franceFlag} alt="Drapeau de la France" className="flag_image" loading="lazy" decoding="async" width="64" height="64" />
                            </div>
                            <div className="flag_wrapper">
                                <img src={ukFlag} alt="Drapeau du Royaume-Uni" className="flag_image" loading="lazy" decoding="async" width="64" height="64" />
                            </div>
                            <div className="flag_wrapper">
                                <img src={turkeyFlag} alt="Drapeau de la Turquie" className="flag_image" loading="lazy" decoding="async" width="64" height="64" />
                            </div>
                        </div>
                        <div className="service_text text-center m-2">
                            Français · Anglais · Turc — cours pour tous niveaux, en présentiel et à distance.
                        </div>
                    </div>

                    <div id="nouscontacter" className="contact-form-container" tabIndex="-1">
                        <h3>📧 Contactez-nous</h3>
                        <p className="form-description">
                            Vous souhaitez en savoir plus sur nos cours de langues ?
                            Laissez-nous vos coordonnées et nous vous recontacterons rapidement.
                        </p>

                        <form onSubmit={handleSubmit} className="contact-form">
                            <div className="form-group">
                                <input
                                    type="text"
                                    name="nom"
                                    placeholder="Nom et prénom *"
                                    value={formData.nom}
                                    onChange={handleInputChange}
                                    className={errors.nom ? 'error' : ''}
                                    disabled={isSubmitting}
                                />
                                {errors.nom && <span className="error-message">{errors.nom}</span>}
                            </div>

                            <div className="form-group">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Adresse email *"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    className={errors.email ? 'error' : ''}
                                    disabled={isSubmitting}
                                />
                                {errors.email && <span className="error-message">{errors.email}</span>}
                            </div>

                            <div className="form-group">
                                <input
                                    type="tel"
                                    name="telephone"
                                    placeholder="Numéro de téléphone *"
                                    value={formData.telephone}
                                    onChange={handleInputChange}
                                    className={errors.telephone ? 'error' : ''}
                                    disabled={isSubmitting}
                                />
                                {errors.telephone && <span className="error-message">{errors.telephone}</span>}
                            </div>

                            <div className="form-group">
                                <input
                                    type="text"
                                    name="sujet"
                                    placeholder="Objet de votre demande *"
                                    value={formData.sujet}
                                    onChange={handleInputChange}
                                    className={errors.sujet ? 'error' : ''}
                                    disabled={isSubmitting}
                                />
                                {errors.sujet && <span className="error-message">{errors.sujet}</span>}
                            </div>

                            <div className="form-group">
                                <textarea
                                    name="message"
                                    placeholder="Votre message (cours souhaités, niveau actuel, objectifs...) *"
                                    rows="5"
                                    value={formData.message}
                                    onChange={handleInputChange}
                                    className={errors.message ? 'error' : ''}
                                    disabled={isSubmitting}
                                ></textarea>
                                {errors.message && <span className="error-message">{errors.message}</span>}
                            </div>

                            <button
                                type="submit"
                                className="submit-btn"
                                disabled={isSubmitting || !firebaseReady}
                                title={emailReady ? 'Email auto-réponse actif' : 'Email en cours d\'initialisation'}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner"></span>
                                        Envoi en cours...
                                    </>
                                ) : (
                                    <>
                                        <i className="fa fa-paper-plane"></i>
                                        {firebaseReady ? 'Envoyer ma demande' : 'Service temporairement indisponible'}
                                    </>
                                )}
                            </button>

                            {status && (
                                <div className={`status-message ${status.includes('✅') ? 'success' : 'error'}`}>
                                    {status}
                                </div>
                            )}
                        </form>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default IntroductionFirebase;
